import { Component, input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { IconComponent } from '../../icon/icon.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'htx-datepicker-field',
  imports: [
    ReactiveFormsModule,
    IconComponent,
    NgClass
  ],
  templateUrl: './datepicker-field.component.html',
  styleUrl: './datepicker-field.component.scss'
})
export class DatepickerFieldComponent {
  private uniqueId = Math.random().toString(36).substring(2, 11);

  /** FormControl instance for managing the date input's value and validation state */
  ctrl = input.required<AbstractControl>();

  /** Label text displayed above the date input field */
  label = input<string>('');

  /** Whether to display a required indicator (*) next to the label */
  required = input<boolean>(false);

  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }

  getUniqueId(): string {
    return this.uniqueId;
  }

  /**
   * Format Date object to YYYY-MM-DD string for date input
   * Simple and reliable conversion without timezone issues
   */
  formatDateForInput(value: any): string {
    if (!value) return '';

    let date: Date;
    if (value instanceof Date) {
      date = value;
    } else if (typeof value === 'string') {
      // If it's already a string in YYYY-MM-DD format, return as is
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value;
      }
      // Try to parse as date string
      date = new Date(value);
    } else {
      return '';
    }

    // Validate date
    if (isNaN(date.getTime())) {
      return '';
    }

    // Use toISOString and take only the date part (YYYY-MM-DD)
    // This handles timezone offsets reliably
    return date.toISOString().split('T')[0];
  }

  /**
   * Parse YYYY-MM-DD string from date input to Date object
   */
  parseDateFromInput(value: string): Date | null {
    if (!value || !value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return null;
    }

    // Create date from string - the input always returns YYYY-MM-DD
    const date = new Date(value);

    // Validate it's a real date
    if (isNaN(date.getTime())) {
      return null;
    }

    return date;
  }

  onDateChange(event: any): void {
    const control = this.getControl();
    const dateString = event.target.value;
    const dateObj = this.parseDateFromInput(dateString);
    control.setValue(dateObj, { emitEvent: true });
  }

  onDateBlur(): void {
    const control = this.getControl();
    control.markAsTouched();
  }
}
